import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import { Typography} from "antd";
import * as XLSX from 'xlsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';  
import { list as UsersList } from "../../../../controllers/V1/users/usersController";

import { list } from "../../../../controllers/V1/recharges/bPointsController";

import Loading from "../../../../components/Loading/LoadingEffect";
import { Link } from "react-router-dom";
import moment from "moment";
const VendorListDeletePopUp = ({ popUpOpen, togglePopUp }) => {
  const handleCancel = () =>  togglePopUp();

  const [isLoading, setIsLoading] = useState(false);
  
  const handleExport = async (e) => {
    e.preventDefault(0);
    try {
      setIsLoading(true);
      const formData = new FormData(e.target);
      let userList = [];
      if(
          formData.get('users_name') || 
          formData.get('last_name') || 
          formData.get('users_mobile') || 
          formData.get('users_email') 
        ){
        const userOption = {
          condition : { 
            ...(formData.get('users_name')?{users_name : { $regex: formData.get('users_name'), $options: "i" } }:null),
            ...(formData.get('last_name')?{last_name : { $regex: formData.get('last_name'), $options: "i" } }:null),
            ...(formData.get('users_email')?{users_email : { $regex: formData.get('users_email'), $options: "i" } }:null),
            ...(formData.get('users_email')?{users_email : { $regex: formData.get('users_email'), $options: "i" } }:null),
            
          },
          select : {_id : true}
        }
        const usrRes = await UsersList(userOption);
        if(usrRes.status === true){
          const usrList = usrRes.result
          if(usrList.length > 0){
            userList = usrList.map((item)=>item._id);
          }
        }
      }
      const option = {
        isExport : true,
        condition : { 
          ...(formData.get('created_by_users_type')?{created_by_users_type : formData.get('created_by_users_type')}:null),
          ...(formData.get('record_type')?{record_type : formData.get('record_type')}:null),

          ...(formData.get('narration')?{narration : { $regex: formData.get('users_name'), $options: "i" }}:null),
          ...(formData.get('points')?{points : parseInt(formData.get('users_mobile'))}:null),
          ...(formData.get('availableArabianPoints')?{availableArabianPoints : parseInt(formData.get('availableArabianPoints'))}:null),
          ...(formData.get('end_balance')?{end_balance : parseInt(formData.get('end_balance'))}:null),
          ...(userList?.length > 0 && {$or : [{debit_user : {$in : userList}}, {credit_user : {$in : userList}}]})
         },
         select : {
          ...(
            formData.get('select_load_balance_id') ||
            formData.get('select_users_type') ||

            formData.get('select_narration') ||
            formData.get('select_record_type') ||
            formData.get('select_end_balance') ||
            formData.get('select_points') ||
            formData.get('select_availableArabianPoints') ||
            formData.get('select_remarks') ||
            formData.get('select_status') ||
            formData.get('select_updatedAt') ||
            formData.get('select_createdAt') ?({
              ...(formData.get('select_load_balance_id')?{load_balance_id : true}:null),
              ...(formData.get('select_users_type')?{created_by_users_type : true}:null),
              ...(formData.get('select_narration')?{narration : true}:null),
              ...(formData.get('select_record_type')?{record_type : true}:null),
              ...(formData.get('select_points')?{points : true}:null),
              ...(formData.get('select_availableArabianPoints')?{availableArabianPoints : true}:null),
              ...(formData.get('select_end_balance')?{end_balance : true}:null),
              ...(formData.get('select_remarks')?{remarks : true}:null),
              ...(formData.get('select_status')?{status : true}:null),
              ...(formData.get('select_updatedAt')?{updatedAt : true}:null),
              ...(formData.get('select_createdAt')?{createdAt : true}:null),
            }):({
              _id : false,
              __v : false,
              updated_by : false,
              updated_ip : false,
              created_ip : false,
              created_by : false,
              country_code : false,
              token : false
            })
          )
         },
         sort : {_id : -1}
      }
      const res = await list(option);
      if(res.status === true){
        await exportToExcel(res.result);
        // handleCancel();
      }else{
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  }

  const exportToExcel = async (data) => {
    try {
      if(data.length > 0){
        const exportData = data.map((items)=>{
          return {
            ...(items?.load_balance_id && {"Seq. Id" : items?.load_balance_id}),
            ...(items?.record_type && {"Record type" : items?.record_type}),
            ...(items?.created_by_users_type && {"Recharge by" : items?.created_by_users_type}),
            ...(items?.credit_user && {
                  "First name" : items?.credit_user?.users_name,
                  "Last name" : items?.credit_user?.last_name,
                  "Mobile" : items?.credit_user?.users_mobile,
                }),
            ...(items?.points && {"Points" : items?.points}),
            ...(items?.availableArabianPoints && {"Avl. QR-Points" : items?.availableArabianPoints}),
            ...(items?.end_balance && {"End balance" : items?.end_balance}),
            
            ...(items?.narration && {"Narration" : items?.narration}),
            ...(items?.status && {"Status" : items?.status}),
            ...(items?.createdAt && {'Created Date' : moment(items?.createdAt).format('DD-MM-YYYY')}),
            ...(items?.createdAt && {'Created Time' : moment(items?.createdAt).format('hh:mm A')}),
            ...(items?.updatedAt && {"Updated Date" : moment(items?.updatedAt).format('DD-MM-YYYY')}),
            ...(items?.updatedAt && {"Updated Time" : moment(items?.updatedAt).format('hh:mm A')}),
            
          }
        })
        const workbook = XLSX.utils.book_new();
        const worksheet1 = XLSX.utils.json_to_sheet(exportData);
  
        XLSX.utils.book_append_sheet(workbook, worksheet1, "Due");
        XLSX.writeFile(workbook, `Crown King Recharge History${moment().format('YYYY-MM-DD')}.xlsx`);
      } else{
        alert('No data available');
      }
    } catch (error) {
      alert(JSON.stringify(error));
    } finally {
      setIsLoading(false);
    }

  };
  
  return (
    <Dialog
      open={popUpOpen}
      onClose={handleCancel}
      fullWidth={true}
      maxWidth={"md"}
      PaperProps={{
        className: "myDialogPopUp",
      }}
    >
      <div className="myDrawer">
        
        <div className="myDrawer">
          <div className="inventory_popup_title">
            <Typography
              variant="h5"
              component="div"
              gutterBottom
              className="inventory_popup_title_heading"
            >
              Export users's 
            </Typography>
            <Link to={false} style={{ position: "absolute", right: 8, top: 8, color: "#dd5151" }} onClick={handleCancel}><FontAwesomeIcon icon={faTimesCircle}/></Link>
          </div>

          <Typography
            variant="body1"
            component="div"
            className="my_delete_popup_paragraph"
          >
          </Typography>
         
          <Typography
            variant="body1"
            component="div"
            className="my_delete_popup_paragraph"
          >
            <div className="container-fluid">
              <div className="categories_open_popup_main_contnet">
                <form onSubmit={handleExport}>
                  <div className="form-group row">
                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <label for="record_type" className="all_lable_for_vendor_dashbaord" > Record's type : </label>
                      <select name="record_type" id="record_type" className="form-control categories_select_tg_enter_product">
                        <option value='' selected disabled>Choose record's type</option>
                        <option value='Freelancer'>Credit</option>
                        <option value='Freelancer'>Debit</option>
                      </select>
                    </div>

                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <label for="created_by_users_type" className="all_lable_for_vendor_dashbaord" > User's type : </label>
                      <select name="created_by_users_type" id="created_by_users_type" className="form-control categories_select_tg_enter_product">
                        <option value='' selected disabled>Choose user's type</option>
                        <option value='Freelancer'>Admin</option>
                        <option value='Freelancer'>Freelancer</option>
                        <option value='Sales Person'>Sales Person</option>
                        <option value='Retailer'>Retailer</option>
                        <option value='Promoter'>Promoter</option>
                        <option value='Users'>Users</option>
                        <option value='Tester'>Tester</option>
                      </select>
                    </div>

                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <label for="users_name" className="all_lable_for_vendor_dashbaord" > User's name : </label>
                      <input type="text" name="users_name" id="users_name" placeholder="User's name" className="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <label for="last_name" className="all_lable_for_vendor_dashbaord" > User's last name : </label>
                      <input type="text" name="last_name" id="last_name" placeholder="User's last name" className="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <label for="users_mobile" className="all_lable_for_vendor_dashbaord" > User's mobile : </label>
                      <input type="number" name="users_mobile" id="users_mobile" placeholder="User's mobile" class="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <label for="users_email" className="all_lable_for_vendor_dashbaord" > User's email : </label>
                      <input type="text" name="users_email" id="users_email" placeholder="User's email" class="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-6 col-md-5 col-sm-12 col-xs-12">
                      <label for="narration" className="all_lable_for_vendor_dashbaord" > Narration : </label>
                      <input type="text" name="narration" id="narration" placeholder="Area" class="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <label for="points" className="all_lable_for_vendor_dashbaord" >QR-Points : </label>
                      <input type="number" name="points" id="points" placeholder="QR-Points" class="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <label for="availableArabianPoints" className="all_lable_for_vendor_dashbaord" > Avl. QR-Points : </label>
                      <input type="text" name="availableArabianPoints" id="availableArabianPoints" placeholder="Avl. QR-Points " class="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <label for="end_balance" className="all_lable_for_vendor_dashbaord" > End QR-Points : </label>
                      <input type="text" name="end_balance" id="end_balance" placeholder="End QR-Points " class="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <label for="select_name" className="all_lable_for_vendor_dashbaord" > Export fields (If any) : </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_load_balance_id" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_load_balance_id" id="select_load_balance_id" className="form-check-input" /> Seq Id
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_users_type" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_users_type" id="select_users_type" className="form-check-input" /> User's type 
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_users_details" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_users_details" id="select_users_details" className="form-check-input" /> User's Details 
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_points" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_points" id="select_points" className="form-check-input" /> Points 
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_record_type" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_record_type" id="select_record_type" className="form-check-input" /> Record type 
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_narration" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_narration" id="select_narration" className="form-check-input" /> Narration 
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_remarks" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_remarks" id="select_remarks" className="form-check-input" /> Remarks 
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_availableArabianPoints" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_availableArabianPoints" id="select_availableArabianPoints" className="form-check-input" /> Available QR-Points 
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_end_balance" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_end_balance" id="select_end_balance" className="form-check-input" /> End QR-Points 
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_status" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_status" id="select_status" className="form-check-input" /> Status 
                      </label>
                    </div>
                    
                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_createdAt" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_createdAt" id="select_createdAt" className="form-check-input" /> Created At 
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_updatedAt" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_updatedAt" id="select_updatedAt" className="form-check-input" /> Updated At 
                      </label>
                    </div>

                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <div className="inventory_open_popup_action_btn">
                        <button type="button" className="btn btn-light categories_cancel_button" onClick={handleCancel} > Cancel </button>
                        <button type="submit" className="btn btn-danger" > Download Excel </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </Typography>
        </div>
      </div>
      <Loading isLoading={isLoading} text={`Preparing download...`} />
    </Dialog>
  );
};

export default VendorListDeletePopUp;
